// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyPlaceholder_container__25R4v"};